import React, { useMemo } from 'react'
import { parseISO } from 'date-fns'
import { DetailsTimelineChart, timelineIcons } from '@/components/charts'
import { Box, Icon, Logo, Text } from '@maui/elements'

const PointSymbol = (e) => {
  const { datum: { description, last } } = e

  const knownType = Object.keys(timelineIcons).includes(description)

  const circleBaseRadius = 12
  const { d, transform } = timelineIcons[knownType ? description : 'other']

  return (
    <>
      <Box as="circle" cx="0" cy="0" r={circleBaseRadius} fill={last ? 'transparent' : 'colorBrandingMandiantRed'} />
      <Box as="path" d={d} transform={transform} fill={last ? 'transparent' : 'colorActionSecondaryHover'} />
    </>
  )
}

const eventTypeIconMap = {
  'Technique Observed': 'logomark',
  'Campaign Created': 'logomark',
  'Host Command': 'terminal',
  'Malicious Executable': 'bug',
  X509: 'key',
  'Phishing Email': 'mail-bug',
  Event: 'tag',
  'First Observed': 'info',
  unknown: 'info',
}

const TooltipIcon = ({ name, tooltipIcons }) => {
  const iconName = tooltipIcons[name]
  if (iconName === 'logomark') {
    return <Logo name="logomark" width="12px" height="12px"/>
  }
  return <Icon name={iconName}/>
}

const Tooltip = (item) => {
  const { point: { data } } = item
  const date = new Date(data.xFormatted)
  const formattedDate = date.toLocaleDateString([], { month: 'long', day: 'numeric', year: 'numeric' })
  return (
    <Box>
      <Box
        width='100%'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        background='colorBrandingMandiantRed'
        color='colorTextEmphasis'
        padding='8px 8px 6px 8px'
        { ...data.first && { marginLeft: '10px' }}
        { ...data.last && { marginRight: '10px' }}
        zIndex='100000'
        gap='4px'
        borderRadius='4px'
      >
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" gap="4px">
          <TooltipIcon name={data.name} tooltipIcons={eventTypeIconMap}/>
          <Text
            fontWeight='700'
            fontSize='12px'
            textAlign='center'
            whiteSpace='nowrap'
          >{ data.description }</Text>
        </Box>
        <Text fontWeight='400' fontSize='12px'>{ formattedDate }</Text>
      </Box>
      <Box
        width='0'
        height='0'
        marginLeft='calc(50% - 10px)'
        borderLeft='10px solid transparent'
        borderRight='10px solid transparent'
        borderTopColor='colorBrandingMandiantRed'
        borderTopWidth='10px'
        borderTopStyle='solid'
        fontSize='0'
        lineHeight='0'
      ></Box>
    </Box>
  )
}

export function CampaignTimeline({ formattedTimeline: lineData, fromModal }) {
  const firstDate = useMemo(() => {
    return parseISO(lineData[0].data[0].x)
  }, [lineData])

  const lastDate = useMemo(() => {
    return parseISO(lineData[0].data[lineData[0].data.length - 1].x)
  }, [lineData])

  const handlePointClick = (point) => {
    if (!fromModal) return
    const href = `/campaigns/${point.serieId}`
    const hash = '#timeline'
    // route the user to the campaign timeline tab
    window.location.href = href + hash
  }

  return <DetailsTimelineChart
    data={lineData}
    tooltip={Tooltip}
    handlePointClick={handlePointClick}
    pointSymbol={PointSymbol}
    firstDate={firstDate}
    lastDate={lastDate}
  />
}

export default CampaignTimeline
